import { formatSAR } from "@/utils/format";

interface SettlementSummaryProps {
  cashDebt: number;
  amount: number;
  remaining: number;
  methodLabel: string;
}

export default function SettlementSummary({
  cashDebt,
  amount,
  remaining,
  methodLabel,
}: SettlementSummaryProps) {
  const rows = [
    {
      label: "إجمالي رسوم التطبيق المستحقة لطلبات الكاش",
      value: formatSAR(cashDebt),
      icon: "ri-hand-coin-line",
      tone: "bg-red-100 text-red-600",
      valueClass: "text-red-600",
    },
    {
      label: "المبلغ المراد سداده",
      value: formatSAR(amount),
      icon: "ri-money-dollar-circle-line",
      tone: "bg-primary-100 text-primary-700",
      valueClass: "text-foreground-950",
    },
    {
      label: "وسيلة الدفع",
      value: methodLabel,
      icon: "ri-bank-card-line",
      tone: "bg-accent-100 text-accent-800",
      valueClass: "text-foreground-950",
    },
    {
      label: "المبلغ المتبقي بعد السداد",
      value: formatSAR(remaining),
      icon: "ri-scales-3-line",
      tone: "bg-secondary-200 text-secondary-800",
      valueClass: "text-foreground-950",
    },
  ];

  return (
    <section className="yc-fade-up bg-white rounded-card border border-background-200 shadow-card p-5 md:p-6">
      <div className="flex items-center gap-2 mb-4">
        <span className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-200 text-secondary-800">
          <i className="ri-file-list-3-line"></i>
        </span>
        <h3 className="text-base font-bold text-foreground-950">
          ملخص السداد
        </h3>
      </div>

      <ul className="space-y-2 text-sm">
        {rows.map((row) => (
          <li
            key={row.label}
            className="flex flex-wrap items-center justify-between gap-2 rounded-btn bg-background-50 px-4 py-3"
          >
            <span className="inline-flex items-center gap-2 text-foreground-600">
              <span
                className={`w-7 h-7 flex items-center justify-center rounded-full text-sm ${row.tone}`}
              >
                <i className={row.icon}></i>
              </span>
              {row.label}
            </span>
            <span className={`font-bold ${row.valueClass}`}>{row.value}</span>
          </li>
        ))}
      </ul>
    </section>
  );
}